import { DateRangePicker } from "@repo/ui/components/ui/date-range-picker"
import { DataTableFilterField } from "@repo/ui/hooks/use-data-table"
import { STANDARD_PRESETS } from "@repo/ui/lib/date-presets"
import { Table } from "@tanstack/react-table"
import { useCallback } from "react"
import { DateRange } from "react-day-picker"
import { useTranslations } from "use-intl"

interface DataTableDatePickerProps<TData> {
  filterField: DataTableFilterField<TData>
  table: Table<TData>
  onDateRangeChange?: (value?: DateRange) => void
}

function DataTableDatePicker<TData>({
  table,
  filterField,
  onDateRangeChange,
}: DataTableDatePickerProps<TData>) {
  const t = useTranslations("ui.dataTable")
  const column = table.getColumn(String(filterField.id))
  const filterValue = column?.getFilterValue()
  const date =
    filterValue && typeof filterValue === "object" && "from" in filterValue
      ? (filterValue as DateRange)
      : undefined

  const handleChange = useCallback(
    (range: DateRange | undefined) => {
      column?.setFilterValue(range)
      if (onDateRangeChange) onDateRangeChange(range)
    },
    [column, onDateRangeChange],
  )

  const placeholder = filterField.placeholder ?? t("filterByDate")

  return (
    <DateRangePicker
      value={date}
      onChange={handleChange}
      placeholder={placeholder}
      presets={STANDARD_PRESETS}
      clearable
    />
  )
}
export default DataTableDatePicker
